import Config from '@/config'
import { randomBoolean } from '@/utils/generators'
import Data from './data'
import { compareValues } from './utils'

const PER_PAGE = Config.isDev ? 100 : 1000
const TOTAL = PER_PAGE * 8
const DATA = Data.outputs.list(TOTAL)
const META = {
    page: 1,
    perPage: PER_PAGE,
    total: TOTAL,
    lastPage: TOTAL / PER_PAGE,
}
const sort = (data, keys) => keys.reduce((acc, { colId, sort: order }) => acc.sort(compareValues(colId, order)), data)
const filter = data => data

export default {
    get: ({ params }) => {
        const {
            id, pagination, filters = {}, sorts = [],
        } = params
        if (id) {
            const length = id === '-1' ? 0 : 1
            return [200, { data: Data.outputs.list(length) }]
        }
        if (!pagination) return [200, { data: DATA }]

        const { page, perPage } = pagination
        const origin = perPage * (page - 1)
        let data = [...DATA.rows]

        if (sorts.length) data = sort(data, sorts)
        if (Object.keys(filters)) data = filter(data, filters)

        return [200, {
            data: {
                ...DATA,
                rows: page <= META.lastPage ? data.splice(origin, perPage) : [],
            },
            meta: {
                ...META,
                page,
            },
        }]
    },
    historic: ({ params }) => [200, Data.historic],
    edit: ({ params }) => (randomBoolean() ? [200] : [400]),
}
